import { Card as MUICard, styled, Box } from "@mui/material";

const StyledCard = styled(MUICard)(({ width, height, style }) => ({
  width: width || "15vw",
  height: height || "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: ".5vw",
  // gap: ".5vw",
  background: "#0D0D0D",
  ...style,
}));

const Card = ({ width, height, style = {}, children, ...props }) => {
  return (
    <Box>
      <StyledCard width={width} height={height} style={style} {...props}>
        {children}
      </StyledCard>
    </Box>
  );
};
export default Card;
